/*
	添加空中雷达几何体创建  刘雨  20170708
*/
import BoundingSphere from "./BoundingSphere.js";
import Cartesian3 from "./Cartesian3.js";
import ComponentDatatype from "./ComponentDatatype.js";
import defaultValue from "./defaultValue.js";
import defined from "./defined.js";
import Ellipsoid from "./Ellipsoid.js";
import Geometry from "./Geometry.js";
import GeometryAttribute from "./GeometryAttribute.js";
import GeometryAttributes from "./GeometryAttributes.js";
import PrimitiveType from "./PrimitiveType.js";
import VertexFormat from "./VertexFormat.js";

function FeGeometryCreator(options) {
  options = defaultValue(options, defaultValue.EMPTY_OBJECT);

  var feGeometry = options.feGeometry;
  if (!defined(feGeometry)) {
    return;
  }

  this._feGeometry = feGeometry;
  this._ellipsoid = Ellipsoid.clone(defaultValue(options.ellipsoid, Ellipsoid.WGS84));
  this._vertexFormat = VertexFormat.clone(defaultValue(options.vertexFormat, VertexFormat.DEFAULT));
  this._workerName = 'createFeGeometry';
  this._primitiveType = defaultValue(options.primitiveType, PrimitiveType.TRIANGLES);
}

FeGeometryCreator.createGeometry = function (feGeometryCreator) {

  var vertexFormat = feGeometryCreator._vertexFormat;
  var ellipsoid = feGeometryCreator._ellipsoid;

  var geo = new Geometry({
    attributes: new GeometryAttributes(),
    primitiveType: feGeometryCreator._primitiveType
  });

  geo.attributes.position = new GeometryAttribute({
    componentDatatype: ComponentDatatype.DOUBLE,
    componentsPerAttribute: 3,
    values: feGeometryCreator._feGeometry._vertexArray
  });

  if (vertexFormat.st) {
    geo.attributes.st = new GeometryAttribute({
      componentDatatype: ComponentDatatype.FLOAT,
      componentsPerAttribute: 2,
      values: feGeometryCreator._feGeometry._textureArray
    });
  }

  geo.indices = feGeometryCreator._feGeometry._indexArray;

  var boundingSphere = BoundingSphere.fromVertices(geo.attributes.position.values, Cartesian3.ZERO, 3);

  return new Geometry({
    attributes: geo.attributes,
    indices: geo.indices,
    primitiveType: geo.primitiveType,
    boundingSphere: boundingSphere
  });
};

export default FeGeometryCreator;
